<template>
    <div>
        <section class="flex my-3 justify-between">
            <div class="flex">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 my-auto">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                </svg>
                <span class="truncate my-auto">IMPORTADOR MASIVO DE REPORTE DE ENTREGAS</span>
            </div>
            <div class="dropdown ml-auto sm:ml-0">
                <button
                    class="dropdown-toggle btn px-2 bg-gray-200"
                    aria-expanded="false"
                >
                    <span class="flex items-center justify-center">
                        <i class="pi pi-download mr-2"></i>
                        Descargar plantillas
                    </span>
                </button>
                <div class="dropdown-menu" style="width: 260px;">
                    <div class="dropdown-menu__content box dark:bg-dark-1 p-2">
                        <button @click="DownXls('programacion')"
                            class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md w-full">
                            <span class="truncate">Excel Programación Masiva</span>
                        </button>
                        <button @click="DownXls('entregas')"
                            class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md w-full">
                            <span class="truncate">Excel Entregas Masivas</span>
                        </button>
                        <button @click="DownXls('RepEntrega')"
                            class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md w-full">
                            <span class="truncate">Excel Reporte Entregas Masivas</span>
                        </button>
                        <button @click="DownXls('AnulEntrega')"
                        class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md w-full">
                            <span class="truncate">Excel Anulación Entrega</span>
                        </button>
                        <button @click="DownXls('AnulRep')"
                            class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md w-full">
                            <span class="truncate">Excel Anulación Reporte Entregas</span>
                        </button>
                        <button @click="DownXls('AnulProg')"
                            class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md w-full">
                            <span class="truncate">Excel Anulación programación Masivas</span>
                        </button>
                    </div>
                </div>
            </div>
            <button
                class="btn px-2 bg-primary-1 text-white mx-2"
                @click="accion(TipoImport)"
            >
                <span class="flex items-center justify-center">
                    <i class="pi pi-send mr-2"></i>
                    Enviar
                </span>
            </button>
        </section>
        <section class="grid grid-cols-2">
            <div class="flex flex-wrap">
                <p class="w-full">Seleccionar tipo de importación:</p>
                <div class="field-radiobutton radio-import p-2 m-2">
                    <RadioButton inputId="entregaMasiva" name="entregaMasiva" value="Programacion" v-model="TipoImport" />
                    <label for="entregaMasiva" class="ml-2">Programación Masivas</label>
                </div>
                <div class="field-radiobutton radio-import p-2 m-2">
                    <RadioButton inputId="entregaMasiva" name="entregaMasiva" value="Entregar" v-model="TipoImport" />
                    <label for="entregaMasiva" class="ml-2">Entregas Masivas</label>
                </div>
                <div class="field-radiobutton radio-import p-2 m-2">
                    <RadioButton inputId="repEntrega" name="repEntrega" value="Reportar" v-model="TipoImport" />
                    <label for="repEntrega" class="ml-2">Reporte Entregas Masivas</label>
                </div>
                <div class="field-radiobutton radio-import p-2 m-2">
                    <RadioButton inputId="anulacionEntrega" name="anulacionEntrega" value="AnulaEntrega" v-model="TipoImport" />
                    <label for="anulacionEntrega" class="ml-2">Anulación Entrega</label>
                </div>
                <div class="field-radiobutton radio-import p-2 m-2">
                    <RadioButton inputId="anulRepEntrega" name="anulRepEntrega" value="AnulaReporte" v-model="TipoImport" />
                    <label for="anulRepEntrega" class="ml-2">Anulación Reporte Entrega</label>
                </div>
                <div class="field-radiobutton radio-import p-2 m-2">
                    <RadioButton inputId="anulprogamacion" name="anulprogamacion" value="AnulaProgramacion" v-model="TipoImport" />
                    <label for="anulprogamacion" class="ml-2">Anulación Programación Masivas</label>
                </div>
            </div>
            <div class="">
                <FileUpload name="demo[]" url="./upload.php" :showUploadButton="false" accept=".xls, .xlsx" :maxFileSize="1000000" @upload="onUpload" @change="handleFilesUpload()" ref="inputFile">
                <template #empty>
                    <p>Arrastra el documento aquí</p>
                </template>
            </FileUpload>
            </div>
        </section>
        <section>
            <DataTable v-if="storeMipresList.rows.length" :value="storeMipresList.rows" class="p-datatable-sm" :rowHover="true" columnResizeMode="expand"
                :paginator="true" :rows="10" :scrollable="true" showGridlines
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll"
                currentPageReportTemplate="Registros {first} a {last} de {totalRecords}"
                    >
                <template #header>
                    <div class="flex justify-end">
                        <InputText v-model="filters.search" type="text" placeholder="Buscar" class="rounded-md" />
                    </div>
                </template>
                <Column field="ID" header="Id" :sortable="true" style="min-width:120px"></Column>
                <Column field="IDDireccionamiento" header="ID Direccionamiento" style="min-width:150px" :sortable="true"></Column>
                <Column header="No Prescripción" style="min-width:200px" :sortable="true">
                    <template #body="{data}">
                        <p style="overflow-wrap: break-word">{{data.NoPrescripcion}}</p>
                    </template>
                </Column>
                <Column field="FechaDir" header="Fecha Dir" style="min-width:110px" :sortable="true"></Column>
                <Column field="FechaMaxEnt" header="Fecha Max Ent" style="min-width:130px" :sortable="true"></Column>
                <Column field="TipoIDPaciente" header="Tipo Doc" style="min-width:110px" :sortable="true"></Column>
                <Column field="NoIDPaciente" header="No Ident Pacient" style="min-width:150px" :sortable="true"></Column>
                <Column field="paciente_nombre" header="Nombre Paciente" style="min-width:200px" :sortable="true"></Column>
                <Column field="cliente_nombre" header="Nombre EPS" style="min-width:180px" :sortable="true"></Column>
                <Column field="NoIDEPS" header="Nit EPS" style="min-width:120px" :sortable="true"></Column>
                <Column field="NoEntrega" header="N Entrega" style="min-width:120px" :sortable="true"></Column>
                <Column field="NoSubEntrega" header="N SubEntrega" style="min-width:140px" :sortable="true"></Column>
                <Column field="NoIdProv" header="Nit Proveedor" style="min-width:150px" :sortable="true"></Column>
                <Column field="DirPaciente" header="Dirección Paciente" style="min-width:150px" :sortable="true"></Column>
                <Column field="NoIdProv" header="Lugar Entrega Paciente" style="min-width:150px" :sortable="true"></Column>
                <Column field="NoIdProv" header="CodServicioTec" style="min-width:150px" :sortable="true"></Column>
                <Column field="NoIdProv" header="Total Entrega" style="min-width:150px" :sortable="true"></Column>
                <Column field="NoIdProv" header="NomServicioTec" style="min-width:150px" :sortable="true"></Column>
                <Column header="Estado Actual" style="min-width:150px" alignFrozen="right" frozen>
                    <template #body="{data}">
                        <div class="relative flex items-center">
                            <div :class="`${tipoEstado(data.estado)} font-semibold p-1 rounded`">
                                {{data.estado}}
                            </div>
                        </div>
                    </template>
                </Column>
            </DataTable>
        </section>
        <!-- BEGIN: Respuestas de la acción -->
        <Dialog v-model:visible="displayRespuestas" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '40vw'}">
            <template v-slot:header>
                <div class="w-full">
                    <div class="flex justify-center">
                        <!-- <img src="/img/icon_circle_refresh_blue.svg" class="cursor-pointer m-1" alt=""> -->
                        <i class="pi pi-file-excel text-4xl text-gray-500"></i>
                    </div>
                </div>
            </template>
            <div class="flex">
                <h2 class="text-center mx-auto text-2xl font-bold mb-2">
                    Respuestas de la acción
                </h2>
            </div>
            <div class="flex justify-center text-xs m-3">
                <div class="col-6" style="max-width: 100%">
                    <p v-for="(data, key) in storeMipresResp" :key="key" style="overflow-wrap: break-word">{{ data.Errors ? data.Errors : data }}</p>
                </div>
            </div>
            <template #footer>
                <Button label="Cerrar" icon="pi pi-times" class="p-button-secondary p-button-outlined" @click="displayRespuestas = false" />
            </template>
        </Dialog>
        <!-- END: Respuestas de la acción -->
        <Toast />
    </div>
</template>
<script>
import { computed, onMounted, ref } from 'vue'
import storeMipres from '../stores/storeMipres'
import axios from 'axios'
import { useRoute } from 'vue-router'
import { useStore } from '@/store'
import XLSX from 'xlsx'
import { error } from '../../../../../libs/mensajes'
import Swal from 'sweetalert2'
import dayjs from 'dayjs'
import { useToast } from 'primevue/usetoast'
export default {
    setup () {
        const store = useStore()
        const storeMipresList = computed(() => storeMipres.getters.getMipresMasivo)
        const storeMipresResp = computed(() => storeMipres.getters.getRespuesta)
        const inputFile = ref()
        const datosExcel = ref([])
        const route = useRoute()
        const toast = useToast()
        const displayRespuestas = ref(false)
        const onUpload = () => {
            toast.add({ severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000 })
        }
        const filters = ref({
            search: ''
        })

        const DownXls = (tipo) => {
            // storeMipres.dispatch('getTemplate', { tipo })
            const url = `${process.env.VUE_APP_MICROSERVICE_API_MIPRES}/export-template-xls`
            const token = store.getters['auth/getToken']
            const obj = { tipo, token }
            const res = axios.getUri({ url, params: obj })
            // console.log('res', res)
            window.open(res, '_blank')
        }

        const cargarTemplate = () => {
            console.log('cargar template')
        }

        const getListMipres = async (filters) => {
            filters.search = ''
            const params = {
                    // limit: 10,
                    offset: 0,
                    // idPettyCashIncome: route.params.id,
                    ...filters
                }
            await storeMipres.dispatch('searchMipresMasivo', { ...params })
                setTimeout(() => {
                    console.log('storeMipresList', storeMipresList.value.rows)
                    if (!storeMipresList.value.rows.length) {
                        toast.add({ severity: 'info', summary: 'Informacion', detail: 'No se encontraron mipres', life: 3000 })
                    }
                }, 1000)
        }

        const accion = (tipo) => {
            var datosExc = datosExcel.value
            if (!datosExcel.value.length) {
                Swal.fire(
                'Advertencia',
                'Debe cargar un Excel antes de enviar',
                'warning'
              )
            } else {
                for (const item of datosExcel.value) {
                    for (const f of storeMipresList.value.rows) {
                        switch (TipoImport.value) {
                            case 'Programacion':
                            if (f.ID === (+item.ID)) {
                                    item.id_mipres = f.ID
                                }
                                break
                            case 'Entregar':
                            case 'Reportar':
                            case 'AnulaProgramacion':
                                if (f.ID === (+item.ID)) {
                                    item.id_mipres = f.ID
                                    item.IdProgramacion = f.IdProgramacion
                                }
                                break
                            case 'AnulaEntrega':
                                if (f.IdEntrega === (+item.IDEntrega)) {
                                    item.id_mipres = f.ID
                                }
                                break
                            case 'AnulaReporte':
                                if (f.IdReporteEntrega === (+item.IdReporteEntrega)) {
                                    item.id_mipres = f.ID
                                }
                                break
                            default:
                                break
                        }
                    }
                }
                const datos = { tipo, datos: datosExc }
                Swal.fire({
                    title: 'Esta seguro/a?',
                    text: 'de actualizar los mipres?',
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, actualizar!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        storeMipres.dispatch('accionMipres', { ...datos, idPettyCashIncome: route.params.id }).then(() => {
                            toast.add({ severity: 'success', summary: 'Exito', detail: 'Se actualizaron los mipres correctamente', life: 3000 })
                            storeMipresList.value.rows = []
                            inputFile.value.files = []
                            TipoImport.value = ''
                            displayRespuestas.value = true
                        }).catch((err) => {
                            console.error(err.message)
                            error(err.response.data.message)
                            displayRespuestas.value = true
                        })
                    } else {
                        // toast.add({ severity: 'info', summary: 'Informacion', detail: 'Se cancelo correctamente', life: 3000 })
                    }
                })
            }
        }

        const handleFilesUpload = () => {
            // loader.show()
            const file = inputFile.value.files[0]
            if (file) {
                const reader = new FileReader()
                reader.onload = (event) => {
                    const result = event.target.result
                    const dataOne = new Uint8Array(result)
                    const workbook = XLSX.read(dataOne, { type: 'array', cellDates: true })
                    const firstWorksheet = workbook.Sheets[workbook.SheetNames[0]]
                    const data = XLSX.utils.sheet_to_json(firstWorksheet, { header: 2, raw: false, dateNf: dayjs('DD/MM/YYYY').format('YYYY-MM-DD') })
                    datosExcel.value = data
                    if (data.length === 0) {
                        toast.add({ severity: 'info', summary: 'Informacion', detail: 'No se encontraron mipres en el Excel', life: 3000 })
                    } else {
                        switch (TipoImport.value) {
                            case 'Programacion':
                            case 'Entregar':
                            case 'Reportar':
                            case 'AnulaProgramacion':
                                getListMipres({ ID: data.map(f => f.ID) })
                                break
                            case 'AnulaEntrega':
                                getListMipres({ Entregas: data.map(f => f.IDEntrega) })
                                break
                            case 'AnulaReporte':
                                getListMipres({ IdReporteEntrega: data.map(f => f.IdReporteEntrega) })
                                break
                            default:
                                break
                        }
                    }
                }
                reader.readAsArrayBuffer(file)
            }
        }

        const tipoEstado = (estado) => {
            switch (estado) {
                case 'SIN PROGRAMAR':
                    return 'bg-gray-200'
                case 'PROGRAMADO':
                case 'PROGRAMACION':
                    return 'bg-purple-100 text-purple-800'
                case 'ENTREGADO':
                case 'ENTREGA':
                case 'NO ENTREGADO':
                    return 'bg-teal-100 text-green-700'
                case 'REPORTADO':
                case 'REPORTE ENTREGA':
                    return 'bg-green-light text-green-600'
                case 'ANULADO':
                    return 'bg-red-200 text-danger'
                case 'DIRECCIONAMIENTO':
                    return 'bg-blue-200 text-blue-600 text-danger'
                default:
                    return 'bg-red-200 text-danger'
            }
        }

        onMounted(() => {
        })
        const TipoImport = ref('')

        return {
            filters,
            datosExcel,
            inputFile,
            TipoImport,
            storeMipresList,
            storeMipresResp,
            displayRespuestas,
            accion,
            DownXls,
            onUpload,
            getListMipres,
            cargarTemplate,
            handleFilesUpload,
            tipoEstado
        }
    }
}
</script>
<style lang="scss">
    .radio-import{
        height: 40px;
        width: 278px;
        background-color: #F6F6F6;
        .active{
            border: 1px solid #5887D0;
        }
    }
</style>
